import { IoIosArrowDroprightCircle } from "react-icons/io";
import { Link } from "react-router-dom";
import {
  CHARTERING_AND_OPERATION_SERVICES,
  CREW_MANNING_SERVICES,
  MARINE_AND_TECHNICAL_ADVICE,
  OUR_SERVICES,
  SERVICES,
  SERVICES_TEXT,
  SHIP_BROKING_SERVICES,
  SHIP_CONSTRUCTION_SUPERVISION,
  SHIP_MANAGEMENT,
  SHIP_PURCHASE_INSPECTION,
  SHIP_REPAIR_SUPERVISION,
} from "../../constants/translations";
import scrollToTop from "../../hybrids/functions/scrollToTop";
import { SERVICES_ROUTE } from "../../routes/routes";
const Services = () => {
  return (
    <section className="services-section">
      <div className="content-control mm-width">
        <h2 className="our-services-title">{OUR_SERVICES}</h2>
        <p className="services-text">{SERVICES_TEXT}</p>
        <Link
          to={SERVICES_ROUTE}
          onClick={scrollToTop}
          className="main-btn about-us-btn"
        >
          {SERVICES}
          <IoIosArrowDroprightCircle />
        </Link>
        <div className="services-titles">
          <span className="line mm-width"></span>
          <h3 className="service-title">{SHIP_MANAGEMENT}</h3>
          <h3 className="service-title">{SHIP_CONSTRUCTION_SUPERVISION}</h3>
          <h3 className="service-title">{MARINE_AND_TECHNICAL_ADVICE}</h3>
          <h3 className="service-title">{SHIP_BROKING_SERVICES}</h3>
          <h3 className="service-title has-top-border">
            {SHIP_REPAIR_SUPERVISION}
          </h3>
          <h3 className="service-title has-top-border">
            {SHIP_PURCHASE_INSPECTION}
          </h3>
          <h3 className="service-title has-top-border">
            {CHARTERING_AND_OPERATION_SERVICES}
          </h3>
          <h3 className="service-title has-top-border">
            {CREW_MANNING_SERVICES}
          </h3>
        </div>
      </div>
    </section>
  );
};

export default Services;
